// removed by extract-text-webpack-plugin
module.exports = {"RequestReviewModal":"RequestReviewModal","requestReviewModal":"RequestReviewModal"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModerationCard/ClientModerationCard/RequestReviewModal.scss
// module id = 531
// module chunks = 0